import { memo } from 'react';

const MyInput = memo((props) => {
  const style = {
    img: { height: '32px', width: '32px', border: '1px solid #dee2e4' },
    input: { border: '1px solid #aabfc3' }
  };
  const { data, type, containerClass } = props;
  const onChange = (event) => {
    event.persist();
    data.setFieldValue(data.text, event.target.value);
  };

  if (type === 'long_text') {
    return (
      <>
        <textarea className={containerClass} name={data.text} onChange={(event) => onChange(event)} style={style.input} value={data.values} />
        <div className='text-left text-danger font-12'>{data.errors}</div>
      </>
    );
  } else {
    return (
      <>
        <input className={containerClass} name={data.text} onChange={(event) => onChange(event)} placeholder={data.placeholder} style={style.input} value={data.values} />
        <div className='text-left text-danger font-12'>{data.errors}</div>
      </>
    );
  }
});

MyInput.displayName = 'MyInput';

export default MyInput;
